import FooterSocials from './FooterSocials';

export default FooterSocials;
